import type { ReactNode } from 'react';

export const symbol_hls: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-384v-192q0-10 7-17t17-7q10 0 17 7t7 17v65h98v-65q0-10 7-17t17-7q10 0 17 7t7 17v192q0 10-7 17t-17 7q-10 0-17-7t-7-17v-79h-98v79q0 10-7 17t-17 7q-10 0-17-7t-7-17Zm276 1v-193q0-10 7-17t17-7q10 0 17 7t7 17v168h96q10 0 17 7t7 17q0 10-7 17t-17 7H419q-9 0-16-7t-7-16Zm258 23q-15 0-24.5-9.5T620-394v-22q0-10 9-14t15-10q10 0 17 7t7 17v8h104v-53H654q-14 0-24-10t-10-24v-71q0-15 9.5-24.5T654-600h132q15 0 24.5 9.5T820-566v22q0 10-9 14t-15 10q-10 0-17-7t-7-17v-8H668v53h118q14 0 24 10t10 24v71q0 15-9.5 24.5T786-360H654Z"
		/>
	</svg>
);
